import type { Walker } from "../../shared/avatars.ts";
import { portraitStyle, slotOf, SHEET_W } from "../lib/walker";

/** Circular portrait cropped from the sprite sheet (HTML). */
export function Portrait({ walker, size, ring = false }: { walker: Walker; size: number; ring?: boolean }) {
  return <div className={ring ? "portrait ring" : "portrait"} style={portraitStyle(walker, size)} aria-hidden="true" />;
}

/** Map marker: the same crop inside an SVG clipPath, centred on (0,0) with radius `r`. */
export function MapSprite({ walker, r }: { walker: Walker; r: number }) {
  const o = slotOf(walker);
  const sc = r / o.r;
  const cid = `mk-${walker.race}-${walker.gender}-${walker.cls}`;
  return (
    <g>
      <defs>
        <clipPath id={cid}><circle cx="0" cy="0" r={r} /></clipPath>
      </defs>
      <g clipPath={`url(#${cid})`}>
        <image href={o.url} x={-r - (o.cx - o.r) * sc} y={-r - (o.cy - o.r) * sc} width={SHEET_W * sc} height={SHEET_W * sc} preserveAspectRatio="none" />
      </g>
      <circle cx="0" cy="0" r={r + 0.6} fill="none" stroke="var(--gold)" strokeWidth={1.6} />
    </g>
  );
}
